import { useContext } from "react";

import { BiMove } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { HiArrowNarrowLeft, HiArrowNarrowRight } from "react-icons/hi";

import RowContext from "../context/RowContext";

import "../styles/DisplayRows.css";

function DisplayRows({ currentId, currentStandard }) {
  const rowContext = useContext(RowContext);

  return (
    <div>
      <div className="rows">
        <div className="rows__left-container">
          <button className="rows__button">
            <BiMove />
          </button>
          <button
            className="rows__button"
            onClick={() => rowContext.outdentOnClick(currentId)}
          >
            <HiArrowNarrowLeft />
          </button>
          <button
            className="rows__button"
            onClick={() => rowContext.indentOnClick(currentId)}
          >
            <HiArrowNarrowRight />
          </button>
          <button
            className="rows__button"
            onClick={() => rowContext.deleteOnClick(currentId)}
          >
            <BsTrash />
          </button>
        </div>

        <div className="rows__right-container">
          <div
            className="rows__margin-box"
            style={{
              marginLeft: 15 * currentStandard.nestedLevel,
              marginRight: 40,
              backgroundColor: "rgb(236, 239, 240)",
              height: "2.2rem",
              width: "2.2rem",
            }}
          ></div>
          {rowContext.isCreation && currentStandard.text === "" && (
            <input
              autoFocus
              type="text"
              onKeyPress={(event) =>
                rowContext.enterKeyPressed(event, currentId)
              }
              onChange={rowContext.onInputChange}
            ></input>
          )}
          {rowContext.isEditing && currentId === rowContext.currentIndex && (
            <input
              autoFocus
              type="text"
              onKeyPress={(event) =>
                rowContext.enterKeyPressed(event, currentId)
              }
              onChange={rowContext.onInputChange}
              value={rowContext.inputText}
            ></input>
          )}
          {currentId !== rowContext.currentIndex && (
            <div
              onDoubleClick={() => rowContext.editStandardText(currentId)}
              style={{
                lineHeight: "2.2rem",
                fontWeight: rowContext.returnFontStyle(
                  currentStandard.nestedLevel
                ).fontWeight,
                color: rowContext.returnFontStyle(currentStandard.nestedLevel)
                  .color,
              }}
            >
              {currentStandard.text}
            </div>
          )}
        </div>
      </div>
      <div className="table-divider"></div>
    </div>
  );
}

export default DisplayRows;
